import { db } from './firebase'

// User API

export const doCreateUser = (id, username, email, role, last_active) =>
  db.ref(`users/${id}`).set({
    username,
    email,
    role,
    last_active
  })

export const onceGetUsers = () => db.ref('users').once('value')

export const getCurrentUsername = id => db.ref('/users/' + id).once('value')

export const deleteUser = id => db.ref('/users/' + id).remove()

//Chat App
export const getMessages = userId => db.ref(`users/${userId}/messages`).limitToLast(100)

export const sendMessage = (senderId, receiverId, msgObjectReceiver, msgObjectSender) =>
  db
    .ref(`users/${senderId}/messages`)
    .push(msgObjectSender)
    .then(() => {
      db.ref(`users/${receiverId}/messages`).push(msgObjectReceiver)
    })

export const lastActive = (userId, dateTime) => {
  if (userId) {
    db.ref(`users/${userId}/last_active`).set(dateTime)
  }
}
